import { createContext } from 'preact';

const PlacesContext = createContext();
export default PlacesContext;
